<template lang="pug">
  div(:class="[$style.trustPilot, classes.join(' ')]")
    .text-center.inline-block(:style="css.length > 0 ? css.join(';') : 'width: auto'")
      img(
        src="~/assets/img/trustpilot/brand/brandmark_gr-wht.svg"
        loading="lazy"
        :class="$style.lightLogo"
        width="168"
        height="41"
        alt="Trustpilot")
      img(
        src="~/assets/img/trustpilot/brand/brandmark_gr-blk.svg"
        loading="lazy"
        :class="$style.darkLogo"
        width="168"
        height="41"
        alt="Trustpilot")
      img(
        src="~/assets/img/trustpilot/brand/stars-4.5.svg"
        loading="lazy"
        :class="$style.rating"
        width="168"
        height="31"
        alt="rating")
</template>

<script lang="ts">
import { defineComponent } from "vue"
import TrustpilotBase from "~/components/base/trustpilotBase"

export default defineComponent({
  name: "TrustpilotFooter",
  extends: TrustpilotBase
})
</script>

<style lang="scss" module>
@import "~/assets/scss/trustpilot.scss";
</style>
